export default __webpack_public_path__ + "static/media/goods-respondentia.67d3cd46.png";